import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../components/layout/Navigation';
import CivilImg from '../assets/images/civillaw.webp'
const CivilLawService = () => {
    return (
        <div className="font-sans">
        <Navigation />
        
        {/* Breadcrumb */}
        <div className="container mx-auto px-4 py-4 mt-16 text-center md:text-left">
            <div className="text-gray-500">
            <Link to="/" className="hover:text-green-600">Home</Link> {' > '}
            <Link to="/practice-areas" className="hover:text-green-600">Practice Area</Link> {' > '}
            <span className="text-green-600">Civil Law</span>
            </div>
        </div>
        
        {/* Title */}
        <div className="container mx-auto px-4 pb-8 text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900">Civil Law</h1>
        </div>
        
        {/* Banner Image */}
        <div className="container mx-auto px-4 mb-12">
            <div className="relative rounded-lg overflow-hidden">
            <img 
                src={CivilImg} 
                alt="Civil law - legal documents and gavel" 
                className="w-full object-cover h-[400px]"
            />
            </div>
        </div>
        
        {/* Content Section */}
        <div className="container mx-auto px-4 py-8">
            <div className="max-w-4xl mx-auto space-y-8">
            <div className="space-y-6 text-gray-700 text-lg">
                <p>
                Civil disputes require careful navigation of complex legal frameworks and procedures. At Wisdoms Law, 
                we provide comprehensive civil litigation services throughout Islamabad and Rawalpindi, helping clients 
                resolve disputes efficiently and favorably.
                </p>
                
                <p>
                Our civil law practice has extensive experience handling a wide range of civil matters, from property disputes 
                and contract breaches to recovery suits and injunction proceedings. We understand the nuances of civil 
                litigation in Pakistan's legal system and develop tailored strategies to protect our clients' interests.
                </p>
                
                <p>
                We approach each case with meticulous attention to detail, thorough preparation, and strategic thinking. 
                Our goal is to resolve disputes in the most cost-effective manner possible, whether through negotiation, 
                alternative dispute resolution methods, or litigation when necessary.
                </p>
                
                <p>
                With Wisdoms Law as your advocate in civil matters, you can expect experienced representation focused on 
                achieving your objectives and safeguarding your legal rights throughout the legal process in Islamabad 
                and Rawalpindi's courts.
                </p>
            </div>
            
            <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Our Civil Law Services Include:</h2>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
                    <h3 className="text-xl font-semibold text-green-700 mb-3">Property Disputes</h3>
                    <p className="text-gray-600">
                    Representation in property ownership disputes, boundary conflicts, landlord-tenant issues, 
                    easement rights, and other real estate matters in Islamabad and Rawalpindi.
                    </p>
                </div>
                
                <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
                    <h3 className="text-xl font-semibold text-green-700 mb-3">Contract Disputes</h3>
                    <p className="text-gray-600">
                    Expert handling of breach of contract claims, contract interpretation issues, 
                    and enforcement of contractual rights and obligations.
                    </p>
                </div>
                
                <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
                    <h3 className="text-xl font-semibold text-green-700 mb-3">Recovery Suits</h3>
                    <p className="text-gray-600">
                    Filing and defending suits for recovery of money, damages, or property, 
                    including execution of decrees and judgments in Islamabad and Rawalpindi courts.
                    </p>
                </div>
                
                <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
                    <h3 className="text-xl font-semibold text-green-700 mb-3">Injunctions & Stay Orders</h3>
                    <p className="text-gray-600">
                    Securing temporary and permanent injunctions to prevent harmful actions, 
                    and stay orders to halt proceedings in appropriate circumstances.
                    </p>
                </div>
                
                <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
                    <h3 className="text-xl font-semibold text-green-700 mb-3">Civil Appeals</h3>
                    <p className="text-gray-600">
                    Representation in civil appeals before District Courts, the Islamabad High Court, 
                    and other appellate forums to challenge adverse judgments.
                    </p>
                </div>
                
                <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
                    <h3 className="text-xl font-semibold text-green-700 mb-3">Alternative Dispute Resolution</h3>
                    <p className="text-gray-600">
                    Negotiation, mediation, and arbitration services to resolve civil disputes 
                    efficiently without protracted court proceedings.
                    </p>
                </div>
                </div>
            </div>
            
            <div className="bg-gray-50 p-8 rounded-lg border border-gray-200">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Why Choose Wisdoms Law for Civil Matters?</h2>
                
                <ul className="space-y-4 mt-4">
                <li className="flex items-start">
                    <svg className="w-6 h-6 text-green-600 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span className="text-gray-700">
                    <strong className="font-semibold">In-depth Knowledge of Civil Procedure:</strong> Our team has mastered the intricacies of the Civil Procedure Code and Evidence Act as applied in Islamabad and Rawalpindi courts.
                    </span>
                </li>
                
                <li className="flex items-start">
                    <svg className="w-6 h-6 text-green-600 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span className="text-gray-700">
                    <strong className="font-semibold">Proven Track Record:</strong> We have successfully resolved numerous civil disputes through both litigation and out-of-court settlements in the twin cities.
                    </span>
                </li>
                
                <li className="flex items-start">
                    <svg className="w-6 h-6 text-green-600 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span className="text-gray-700">
                    <strong className="font-semibold">Strategic Approach:</strong> We analyze each case thoroughly to develop customized strategies that align with your goals and maximize your chances of success.
                    </span>
                </li>
                
                <li className="flex items-start">
                    <svg className="w-6 h-6 text-green-600 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span className="text-gray-700">
                    <strong className="font-semibold">Clear Communication:</strong> We keep you informed about your case's progress in straightforward language, explaining complex legal concepts in accessible terms.
                    </span>
                </li>
                
                <li className="flex items-start">
                    <svg className="w-6 h-6 text-green-600 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span className="text-gray-700">
                    <strong className="font-semibold">Cost-Effective Solutions:</strong> We focus on resolving disputes efficiently to minimize costs while maximizing results for our clients.
                    </span>
                </li>
                </ul>
            </div>
            
            {/* Case Studies */}
            <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Recent Success Stories</h2>
                
                <div className="space-y-4 mt-6">
                <div className="border-l-4 border-green-600 pl-4 py-3">
                    <h3 className="font-bold text-lg">Complex Property Dispute Resolution</h3>
                    <p className="text-gray-600">Successfully resolved a multi-party property ownership dispute in Islamabad involving contested inheritance claims, securing our client's rightful ownership after strategic litigation.</p>
                </div>
                
                <div className="border-l-4 border-green-600 pl-4 py-3">
                    <h3 className="font-bold text-lg">Commercial Contract Victory</h3>
                    <p className="text-gray-600">Obtained a favorable judgment in a breach of contract case in Rawalpindi District Court, securing substantial damages for our client when a business partner failed to fulfill contractual obligations.</p>
                </div>
                
                <div className="border-l-4 border-green-600 pl-4 py-3">
                    <h3 className="font-bold text-lg">Emergency Injunction Secured</h3>
                    <p className="text-gray-600">Successfully obtained an urgent stay order from the Islamabad High Court to prevent demolition of our client's property, preserving their rights while the underlying dispute was resolved.</p>
                </div>
                </div>
            </div>
            
            {/* CTA Section */}
            <div className="bg-green-50 p-8 rounded-lg border border-green-100 text-center">
                <h2 className="text-2xl font-bold text-green-800 mb-4">Facing a Civil Dispute in Islamabad or Rawalpindi?</h2>
                <p className="text-green-600 mb-6">
                Contact Wisdoms Law today to schedule a consultation with our experienced civil litigation team.
                </p>
                <div className="flex flex-col sm:flex-row justify-center gap-4">
                <Link 
                    to="/contact" 
                    className="bg-green-600 text-white px-6 py-3 rounded-md font-medium hover:bg-green-700 transition-colors"
                >
                    Schedule Consultation
                </Link>
                <a 
                    href="tel:+923001234567" 
                    className="bg-white text-green-600 border border-green-600 px-6 py-3 rounded-md font-medium hover:bg-green-50 transition-colors"
                >
                    Call Now: +92 300 123 4567
                </a>
                </div>
            </div>
            
            {/* FAQ Section */}
            <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-6">Frequently Asked Questions</h2>
                
                <div className="space-y-4">
                <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
                    <h3 className="font-bold text-lg mb-2">How long do civil cases typically take in Islamabad and Rawalpindi courts?</h3>
                    <p className="text-gray-600">
                    The duration of civil cases varies widely depending on the complexity of the issues, the court's caseload, and the strategies employed. 
                    Simple matters might be resolved in months, while complex property or commercial disputes could take 1-3 years. 
                    At Wisdoms Law, we strive to expedite proceedings as much as possible while maintaining the quality of representation.
                    </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
                    <h3 className="font-bold text-lg mb-2">What documents do I need to file a property dispute case?</h3>
                    <p className="text-gray-600">
                    For property disputes in Islamabad or Rawalpindi, you typically need ownership documents (sale deed, transfer deed, gift deed), 
                    property tax receipts, utility bills, any correspondence related to the dispute, survey reports or maps if boundary issues are involved, 
                    and any prior court orders related to the property. Our team can help you gather and organize the necessary documentation.
                    </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
                    <h3 className="font-bold text-lg mb-2">Is mediation a viable option for resolving civil disputes in Pakistan?</h3>
                    <p className="text-gray-600">
                    Yes, mediation is increasingly recognized as an effective approach to resolving civil disputes in Pakistan, particularly in Islamabad and Rawalpindi. 
                    It can save time, reduce costs, and preserve relationships between parties. The courts also encourage alternative dispute resolution. 
                    Our firm has substantial experience in representing clients in mediation processes with successful outcomes.
                    </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
                    <h3 className="font-bold text-lg mb-2">What is the process for obtaining an injunction or stay order in urgent situations?</h3>
                    <p className="text-gray-600">
                    For urgent injunctions in Islamabad or Rawalpindi, we file an application under Order 39 Rules 1 & 2 of the Civil Procedure Code, 
                    clearly demonstrating the urgency, potential irreparable harm, and prima facie case. In extremely urgent cases, we can request same-day 
                    hearings or ex-parte orders. Our team is experienced in preparing strong applications with supporting evidence to maximize the chances of success.
                    </p>
                </div>
                </div>
            </div>
            </div>
        </div>
        
        {/* Whatsapp Float Button */}
        <div className="fixed bottom-6 right-6 z-50">
            <a 
            href="https://wa.me/923329754400" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="bg-green-500 hover:bg-green-600 text-white p-3 rounded-full shadow-lg flex items-center justify-center w-16 h-16"
            >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="currentColor" viewBox="0 0 24 24">
                <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/>
            </svg>
            </a>
        </div>
        </div>
    );
};

export default CivilLawService;